import { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

function isDarkHour() {
  const h = new Date().getHours();
  return h >= 19 || h < 6;
}

export function ThemeProvider({ children }) {
  const [themeMode, setThemeModeState] = useState(() => {
    return localStorage.getItem('bm-theme-manual') || 'auto';
  });
  const [, setTick] = useState(0);

  // Derive boolean dark flag
  const dark =
    themeMode === 'dark' ||
    (themeMode === 'auto' && isDarkHour());

  const isAuto = themeMode === 'auto';

  // Apply dark class to <html>
  useEffect(() => {
    document.documentElement.classList.toggle('dark', dark);
  }, [dark]);

  // Auto mode: re-evaluate every 60s for time-based switching
  useEffect(() => {
    if (themeMode !== 'auto') return;
    const id = setInterval(() => setTick(t => t + 1), 60000);
    return () => clearInterval(id);
  }, [themeMode]);

  const setThemeMode = (mode) => {
    // 'auto' | 'light' | 'dark'
    setThemeModeState(mode);
    localStorage.setItem('bm-theme-manual', mode);
  };

  // Legacy helpers kept for backward compat with existing pages
  const toggleDark = () => {
    const next = dark ? 'light' : 'dark';
    setThemeMode(next);
  };
  const resetToAuto = () => setThemeMode('auto');

  return (
    <ThemeContext.Provider value={{ dark, themeMode, setThemeMode, toggleDark, resetToAuto, isAuto }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
